import { Person } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  IconButton,
  Stack,
} from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import React from 'react';
import FrameCard from '../FrameCard/FrameCard';

const RadioLikeSelectCard = ({
  title = '',
  src = '',
  defaultAvatar = true,
  AvatarElement = null,
  avatarColor = themeColors.ColorPrimary,
  AdditionalElement,
  isAction = false,
  ActionFn = () => {},
  ActionIcon = <></>,
  ActionColor = 'info',
  customtitle = null,
  onClickCard = null,
  disableAction = false,
  replaceLoading,
  ArrayActions = [],
  VerticalIcons,
  Select,
  isFrameCard,
}) => {
  return (
    <React.Fragment>
      <Stack>
        {isFrameCard ? (
          <FrameCard
            cardProps={{
              transition: 'all .5s ease',
              cursor: onClickCard ? 'pointer' : 'unset',
              backgroundColor: Select
                ? themeColors.ColorSecondary
                : '',
              color: Select ? themeColors.ColorPrimary : '',
              cursor: 'pointer',
              borderColor: `${themeColors.ColorSecondary} !important`,
              padding: '.3em',
              borderRadius: '20px',
            }}
            jsx={
              <div onClick={onClickCard && onClickCard}>
                <Stack
                  direction={
                    VerticalIcons ? 'column' : 'row-reverse'
                  }
                  alignItems="center"
                  justifyContent="space-between"
                  paddingRight="1em"
                  sx={{
                    userSelect: 'none',
                    backgroundColor: 'white',
                    borderRadius: '20px',
                  }}
                  className="radio-like-select-card"
                >
                  {AdditionalElement && AdditionalElement}
                  {!customtitle ? (
                    <p>{title}</p>
                  ) : (
                    customtitle
                  )}
                  {!isAction ? (
                    <Avatar
                      sx={{
                        bgcolor:
                          avatarColor || deepOrange[500],
                        width: 50,
                        height: 50,
                      }}
                      variant="square"
                      src={`data:image/*;base64,${src}`}
                    >
                      {defaultAvatar && !AvatarElement ? (
                        <Person />
                      ) : (
                        <></>
                      )}
                      {AvatarElement || <></>}
                    </Avatar>
                  ) : replaceLoading ? (
                    <Box p="1em">
                      <CircularProgress
                        sx={{
                          color: `${themeColors.ColorPrimary} !important`,
                        }}
                      />
                    </Box>
                  ) : ArrayActions.length > 0 ? (
                    <Stack
                      direction={
                        VerticalIcons ? 'column' : 'row'
                      }
                      gap=".5em"
                      width="100%"
                      mt=".5em"
                      mr="-1em"
                      pb=".5em"
                    >
                      {ArrayActions?.map(
                        (action, index) => (
                          <Button
                            onClick={() => action.fn()}
                            color={action.clr}
                            disabled={action.disabled}
                            startIcon={action.icon}
                            fullWidth={true}
                            variant={action.variant}
                            key={index}
                            sx={{
                              color: `${themeColors.ColorPrimary} !important`,
                            }}
                          >
                            {action.name}
                          </Button>
                        )
                      )}
                    </Stack>
                  ) : (
                    <IconButton
                      onClick={ActionFn}
                      color={ActionColor}
                      disabled={disableAction}
                    >
                      {ActionIcon}
                    </IconButton>
                  )}
                </Stack>
              </div>
            }
          />
        ) : (
          <>
            <Card
              onClick={onClickCard && onClickCard}
              sx={{
                transition: 'all .5s ease',
                cursor: onClickCard ? 'pointer' : 'unset',
                backgroundColor: Select
                  ? themeColors.ColorPrimary
                  : '',
                color: Select
                  ? themeColors.ColorSecondary
                  : '',
                cursor: 'pointer',
                borderColor: `${themeColors.ColorSecondary} !important`,
              }}
              elevation={4}
            >
              <Stack
                direction={
                  VerticalIcons ? 'column' : 'row-reverse'
                }
                alignItems="center"
                justifyContent="space-between"
                paddingRight="1em"
                sx={{ userSelect: 'none' }}
                className="radio-like-select-card"
              >
                {AdditionalElement && AdditionalElement}
                {!customtitle ? (
                  <p>{title}</p>
                ) : (
                  customtitle
                )}
                {!isAction ? (
                  <Avatar
                    sx={{
                      bgcolor:
                        avatarColor || deepOrange[500],
                      width: 50,
                      height: 50,
                    }}
                    variant="square"
                    src={`data:image/*;base64,${src}`}
                  >
                    {defaultAvatar && !AvatarElement ? (
                      <Person />
                    ) : (
                      <></>
                    )}
                    {AvatarElement || <></>}
                  </Avatar>
                ) : replaceLoading ? (
                  <Box p="1em">
                    <CircularProgress
                      sx={{
                        color: `${themeColors.ColorPrimary} !important`,
                      }}
                    />
                  </Box>
                ) : ArrayActions.length > 0 ? (
                  <Stack
                    direction={
                      VerticalIcons ? 'column' : 'row'
                    }
                    gap=".5em"
                    width="100%"
                    mt=".5em"
                    mr="-1em"
                    pb=".5em"
                  >
                    {ArrayActions?.map((action, index) => (
                      <Button
                        onClick={() => action.fn()}
                        color={action.clr}
                        disabled={action.disabled}
                        startIcon={action.icon}
                        fullWidth={true}
                        variant={action.variant}
                        key={index}
                        sx={{
                          color: `${themeColors.ColorPrimary} !important`,
                        }}
                      >
                        {action.name}
                      </Button>
                    ))}
                  </Stack>
                ) : (
                  <IconButton
                    onClick={ActionFn}
                    color={ActionColor}
                    disabled={disableAction}
                  >
                    {ActionIcon}
                  </IconButton>
                )}
              </Stack>
            </Card>
          </>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default RadioLikeSelectCard;
